import { render, staticRenderFns } from "./QuizPlay.vue?vue&type=template&id=b7e87a82&scoped=true&"
import script from "./QuizPlay.vue?vue&type=script&lang=js&"
export * from "./QuizPlay.vue?vue&type=script&lang=js&"
import style0 from "./QuizPlay.vue?vue&type=style&index=0&id=b7e87a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e87a82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VRow})
